import svgIcons from '@/assets/svg/icons';
import CustomButton from '@/components/atoms/CustomButton';
import VerifyEmailConfirmationModal from '@/components/molecules/VerifyEmailConfirmationModal';
import { useAuthContext } from '@/context/auth/useAuthContext';
import { primary } from '@/theme/colors/palettes';
import { Button, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

const PEER_SUPPORT_CREATOR_PROMPT_HIDDEN_KEY = 'peer-support-creator-prompt-hidden';

const CreatorPrompt = () => {
  const navigate = useNavigate();
  const { isContentCreator, user } = useAuthContext();
  const [isHidden, setIsHidden] = useState(false);
  const [isVerifyEmailModalOpen, setIsVerifyEmailModalOpen] = useState(false);

  useEffect(() => {
    setIsHidden(localStorage.getItem(PEER_SUPPORT_CREATOR_PROMPT_HIDDEN_KEY) === 'true');
  }, []);

  const hidePrompt = () => {
    localStorage.setItem(PEER_SUPPORT_CREATOR_PROMPT_HIDDEN_KEY, 'true');
    setIsHidden(true);
  };

  const handleBecomeCreator = () => {
    if (!user?.email_verified) {
      setIsVerifyEmailModalOpen(true);
      return;
    }

    navigate({ to: '/creator/apply' });
  };

  if (isContentCreator || isHidden) return null;

  return (
    <>
      <VStack width={'100%'} maxWidth={'475px'} gap={'10px'} alignSelf={'center'}>
        <VStack gap={'8px'} width={'100%'}>
          <Text variant={'loraMedium18'} color={'text.mediumBlue'} fontWeight={'400'}>
            Want to become Content Creator?
          </Text>

          <Text
            color={'background.blueGray'}
            fontSize={{ base: '14px', md: '14px' }}
            lineHeight={{ base: '17px', md: '17px' }}
            fontWeight={'500'}
            textAlign={'center'}
            maxWidth={'390px'}
          >
            Content Creators can create articles, posts, videos and share with your team, and the MyOmnia community.
          </Text>
        </VStack>

        <CustomButton
          noShadow
          label="Become a Creator"
          labelColor="primary.500"
          iconAfterLabelSvgPath={svgIcons.rightArrow}
          iconAfterLabelSvgColor={primary[500]}
          iconAfterLabelSvgSize={15}
          iconAfterLabelSvgBoxWidth={20}
          iconAfterLabelSvgBoxHeight={13}
          style={{
            width: '360px',
            borderColor: primary[500],
            marginTop: '10px',
          }}
          onClick={handleBecomeCreator}
        />

        <Button
          variant={'ghost'}
          color={'background.blueGray'}
          fontSize={'12px'}
          fontWeight={'900'}
          textTransform={'uppercase'}
          _hover={{ backgroundColor: 'transparent', opacity: 0.7 }}
          onClick={hidePrompt}
        >
          Don't show this message again
        </Button>
      </VStack>

      <VerifyEmailConfirmationModal
        isOpen={isVerifyEmailModalOpen}
        onClose={() => setIsVerifyEmailModalOpen(false)}
        email={user?.email}
      />
    </>
  );
};

export default CreatorPrompt;
